import { useSelector } from 'react-redux';

import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useState, useRef } from 'react';
import webServicesList from './webService.json';
import { getPeriodForDropdown, getCompanyForDropdown } from '../module/luca/utils/util';
import { useEffect } from 'react';
import { createCompany, updateCompany } from './requests/batchRequest';
import { Toast } from 'primereact/toast';
import { portalDefterCheck } from '../module/datasoft/utils/DatasoftRequest';
import { Divider } from 'primereact/divider';
import Loading from '../Loading';

export default function LucaUpdate({ isLoginLuca, response, companyList, username, password, customerNumber, taxNumber, handleReturnList, id, batchId, toastHandler, setIsLoginLuca, updateCompanyData }) {
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [periodList, setPeriodList] = useState([]);
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [eDefterId, setEDefterId] = useState('');
    const [eDefter, setEDefter] = useState('');
    const [loading, setLoading] = useState(false);
    const [lucaCompanyList, setLucaCompanyList] = useState([]);

    const toast = useRef(null);

    useEffect(() => {
        if (isLoginLuca && response) {
            setLucaCompanyList(getCompanyForDropdown(response));
        }
    }, [companyList, isLoginLuca, response, taxNumber]);

    // Pre-populate existing data
    useEffect(() => {
        if (updateCompanyData) {
            if (updateCompanyData.luca_company_id) {
                // Convert to string to match dropdown options
                setSelectedCompany(String(updateCompanyData.luca_company_id));
                if (response && response.length > 0) {
                    // eslint-disable-next-line eqeqeq
                    const foundCompany = response.find((item) => item.company.value == updateCompanyData.luca_company_id);
                    if (foundCompany) {
                        const periods = getPeriodForDropdown(response, updateCompanyData.luca_company_id);
                        setPeriodList(periods);
                    }
                }
            }
            // Set e_defter fields even if null (they'll be empty strings)
            setEDefter(updateCompanyData.e_defter_sube_adi || '');
            setEDefterId(updateCompanyData.e_defter_sube_kodu || '');
        }
    }, [updateCompanyData, response, isLoginLuca]);

    const handleChangeCompany = (e) => {
        setSelectedCompany(e.value);
        setPeriodList(getPeriodForDropdown(response, e.value));
    };

    const validateForm = () => {
        if (isLoginLuca && !selectedCompany) {
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Lütfen bir şirket seçiniz', life: 3000 });
            }, 1);
            return false;
        }

        return true;
    };

    const handleCreateCompanies = async () => {
        if (!validateForm()) {
            return;
        }

        setLoading(true);

        try {
            if (isLoginLuca && selectedCompany) {
                const lucaCompany = response?.find((item) => item.company.value === selectedCompany);

                if (lucaCompany) {
                    const newCompanies = {
                        id: id,
                        luca_company_id: selectedCompany,
                        luca_company_name: lucaCompany.company.label,
                        e_defter_sube_adi: eDefter,
                        e_defter_sube_kodu: eDefterId,
                        username: username,
                        password: password,
                        customer_number: customerNumber
                    };

                    await updateCompany(newCompanies, batchId);

                    toastHandler('success', 'Başarılı', 'Şirket başarıyla güncellendi', 3000);

                    setSelectedCompany(null);
                    setPeriodList([]);
                    setSelectedPeriod(null);
                    setEDefter('');
                    setEDefterId('');
                } else {
                    setTimeout(() => {
                        toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Seçilen şirket bulunamadı', life: 3000 });
                    }, 1);
                }
            } else {
                const newCompanies = {
                    id: id,
                    luca_company_id: '',
                    luca_company_name: '',
                    e_defter_sube_adi: eDefter,
                    e_defter_sube_kodu: eDefterId,
                    username: username,
                    password: password,
                    customer_number: customerNumber
                };

                await updateCompany(newCompanies, batchId);

                toastHandler('success', 'Başarılı', 'Şirket başarıyla güncellendi', 3000);

                setEDefter('');
                setEDefterId('');
            }
        } catch (error) {
            setTimeout(() => {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Şirket oluşturulurken bir hata oluştu', life: 3000 });
            }, 1);
        } finally {
            handleReturnList();
            setLoading(false);
        }
    };

    return (
        <div className="mt-4">
            <Toast ref={toast} />
            {loading ? (
                <div className="flex justify-content-center align-items-center h-screen">
                    <Loading loading={loading} onChangeLoading={() => setLoading(false)} />
                </div>
            ) : (
                <>
                    <div className="text-2xl font-bold mb-4">E Defter Güncelleme - {updateCompanyData?.tax_number}</div>
                    <div>
                        {isLoginLuca && (
                            <div className="py-3">
                                <label className="mb-2 block">Şirketler <span className='text-pink-500'>*</span></label>
                                <Dropdown
                                    dataKey="value"
                                    value={selectedCompany}
                                    onChange={handleChangeCompany}
                                    options={lucaCompanyList}
                                    optionLabel="title"
                                    optionValue="value"
                                    placeholder="Şirket Seçiniz"
                                    filter
                                    className="w-full"
                                    emptyMessage="Şirket Bulunamadı"
                                    appendTo="self"
                                />
                            </div>
                        )}

                        <div className="py-3">
                            <div className="w-full mb-2">
                                <label>E Defter Şube Adı</label>
                            </div>
                            <div className="w-full">
                                <InputText type="text" className="w-full" value={eDefter} onChange={(e) => setEDefter(e.target.value)} placeholder="E Defter Şube Adı" />
                            </div>
                        </div>

                        <div className="py-3">
                            <div className="w-full mb-2">
                                <label>E Defter Şube Kodu</label>
                            </div>
                            <div className="w-full">
                                <InputText
                                    type="text"
                                    className={classNames({ 'p-invalid': eDefterId.length > 0 && eDefterId.length !== 4, 'w-full': true })}
                                    value={eDefterId}
                                    onChange={(e) => e.target.value.length <= 4 && setEDefterId(e.target.value)}
                                    placeholder="E Defter Şube Kodu"
                                />
                                {eDefterId.length > 0 && eDefterId.length !== 4 && <small className="p-error">E Defter Şube Kodu 4 haneli olmalıdır.</small>}
                            </div>
                        </div>

                        <div className="flex justify-content-between align-items-center gap-2">
                            <Button
                                label="Geri"
                                className="p-button-danger text-white w-10rem mt-4"
                                onClick={() => {
                                    handleReturnList();
                                }}
                            />
                            <Button label="Kaydet" className="p-button-success text-white w-10rem mt-4" onClick={handleCreateCompanies} loading={loading} disabled={loading} />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
